export const validatePassword = (password: any) => {
	const hasUpperCase = /[A-Z]/.test(password);
	const hasNumber = /[0-9]/.test(password);
	const isValidLength = password.length >= 8;
	return hasUpperCase && hasNumber && isValidLength;
};
